import type { FontFaces } from './template-loader'

/** Adds the `@font-face` rules of one shipped family to `target`'s head, once per family. */
export async function ensureFontFaces(
  fontFaces: FontFaces,
  family: string,
  target: Document = document,
): Promise<void> {
  const key = family.toLowerCase()
  const present = Array.from(
    target.head.querySelectorAll<HTMLStyleElement>('style[data-font-family]'),
  ).some((style) => style.dataset.fontFamily === key)
  if (present) return
  const style = target.createElement('style')
  style.dataset.fontFamily = key
  target.head.append(style)
  try {
    style.textContent = await fontFaces.cssFor([family])
  } catch {
    style.remove()
  }
}
